// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Type definitions
import { ForgeProjectDocumentPreview } from "./SDKForgeProjectDocumentPreview";
import { ForgeProjectFeaturePreview } from "./SDKForgeProjectFeaturePreview";
export class ForgeProject {
    constructor(model) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.id = model.id;
        this.liveblocksRoomId = model.liveblocksRoomId;
        this.workspaceId = model.workspaceId;
        this.projectContextId = model.projectContextId;
        this.name = model.name;
        this.description = model.description;
        this.instruction = model.instruction;
        this.tags = model.tags;
        this.accessMode = model.accessMode;
        this.defaultRole = model.defaultRole;
        this.effectiveRole = model.effectiveRole;
        this.isArchived = (_a = model.isArchived) !== null && _a !== void 0 ? _a : false;
        this.emoji = model.emoji;
        this.createdAt = new Date(model.createdAt);
        this.createdByUserId = model.createdByUserId;
        this.updatedAt = new Date(model.updatedAt);
        this.numberOfFeatures = (_c = (_b = model.features) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
        this.numberOfDocuments = (_e = (_d = model.documents) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0;
        this.documents =
            (_g = (_f = model.documents) === null || _f === void 0 ? void 0 : _f.map((doc) => new ForgeProjectDocumentPreview(doc))) !== null && _g !== void 0 ? _g : [];
        this.features =
            (_j = (_h = model.features) === null || _h === void 0 ? void 0 : _h.map((feature) => new ForgeProjectFeaturePreview(feature))) !== null && _j !== void 0 ? _j : [];
        this.tokenThemeSetId = model.tokenThemeSetId;
        this.lastUserActivityAt = model.lastUserActivityAt
            ? new Date(model.lastUserActivityAt)
            : undefined;
    }
    toRemote() {
        return {
            ...this,
            documents: this.documents.map((doc) => doc.toRemote()),
            features: this.features.map((feature) => feature.toRemote()),
            createdAt: this.createdAt.toISOString(),
            updatedAt: this.updatedAt.toISOString(),
        };
    }
}
